import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { WorkflowModel } from '../../../model/workflowModel';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { BrokerAuditDataModel } from '../../../model/brokerAuditDataModel';
import { SubmitBrokerAuditDataRequestModel } from '../../../model/submitBrokerAuditDataRequestModel';
import { BadTrustAccountModel } from '../../../model/badTrustAccountModel';
import { Router } from '@angular/router';
import { BrokerAuditDeclarationService } from '../broker-audit-declaration.service';
import { BadOffSiteStorageLocationModel } from '../../../model/badOffSiteStorageLocationModel';
import { MessageModel } from '../../../model/models';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { SubmitBrokerAuditDataResponseModel } from '../../../model/submitBrokerAuditDataResponseModel';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { StorageService } from '../../../shared/security/StorageService';
import * as $ from 'jquery';
import { StringUtils } from '../../../shared/utils/stringUtils';
import { Subscription } from 'rxjs';
import { BrokerAuditDeclarationSaveDataService } from '../broker-audit-declaration-save-data.service';

@Component({
  selector: 'app-section5-ba-data-storage-location',
  templateUrl: './section5-ba-data-storage-location.component.html',
  styleUrls: ['./section5-ba-data-storage-location.component.css']
})
export class Section5BaDataStorageLocationComponent implements OnInit, OnDestroy {

  workflow: WorkflowModel = new WorkflowModel();
  startFunction: StartFunctionResponseModel;
  brokerAuditDataModel: BrokerAuditDataModel = new BrokerAuditDataModel();
  submitBrokerAuditDataRequestModel: SubmitBrokerAuditDataRequestModel = new SubmitBrokerAuditDataRequestModel();
  offSiteStorageLocations: Array<BadOffSiteStorageLocationModel> = [];

  userMessages: Array<MessageModel> = [];

  SaveDataSubscription : Subscription = new Subscription();

  constructor(private router: Router,
    private currentPageWatcher: CurrentPageWatcherService,
    private startFunctionService: StartFunctionService,
    private brokerAuditDeclarationService: BrokerAuditDeclarationService,
    private storageService: StorageService, private stringUtils: StringUtils,
    private brokerAuditDeclarationSaveDataService : BrokerAuditDeclarationSaveDataService) {

    this.brokerAuditDataModel = this.brokerAuditDeclarationService.brokerAuditDataModel
    this.offSiteStorageLocations = this.brokerAuditDataModel.OffSiteStorageLocations;

     //on save current values
     this.SaveDataSubscription =this.brokerAuditDeclarationService.getNotifySaveData().subscribe((data:Boolean)=>{
      if(data == true){
        if (this.handleBadFormErrors() == false) {
          this.submitBrokerAuditDataRequestModel.SubmitAsDraft = true;
          this.submitBrokerAuditDataRequestModel.BrokerAuditData = this.brokerAuditDataModel;
          this.brokerAuditDeclarationSaveDataService.saveBAD(this.submitBrokerAuditDataRequestModel);
        }
      }
    })

  }

  ngOnInit() {

    this.startFunction = this.storageService.getStartFunctionData();

    this.workflow = this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel;
    //add two empty rows to generalAccounts list (if the list is empty)
    if (this.offSiteStorageLocations.length == 0) {
      this.offSiteStorageLocations.push({ FacilityAddress: "", FacilityName: "" });
      this.offSiteStorageLocations.push({ FacilityAddress: "", FacilityName: "" });
      this.offSiteStorageLocations.push({ FacilityAddress: "", FacilityName: "" });
      this.offSiteStorageLocations.push({ FacilityAddress: "", FacilityName: "" });

    }

    this.submitBrokerAuditDataRequestModel.WorkflowID = this.workflow.WorkflowID;
    this.submitBrokerAuditDataRequestModel.CurrentStepIndex = this.workflow.CurrentStepIndex;

  }

  addRowSec() {
    this.offSiteStorageLocations.push({ FacilityAddress: "", FacilityName: "" });

  }

  onContinueSection() {
    if(this.handleBadFormErrors() == false){
       //find next section = first section in the list with value greater than 5 (actual section)
       let nextSection = this.brokerAuditDeclarationService.brokerDataDeclarationSectionList.find(function (number) {
        return number > 5;
      });
      console.log("next section : ", nextSection);

      
      switch (nextSection) {

        case 6: {
          this.router.navigate(['/section6BaData']);

          break;
        }

        case 7: {
          this.router.navigate(['/section7BaData']);

          break;
        }

        case 8: {
          this.router.navigate(['/section8BaData']);

          break;
        }

        case 9: {
          this.router.navigate(['/section9BaData']);
          break;
        }
        default: {
          this.submitBrokerAuditDeclarationData();
          break;
        }
      }
    }
    
  }

  submitBrokerAuditDeclarationData() {
    this.offSiteStorageLocations = this.offSiteStorageLocations.filter(el => this.stringUtils.isNotEmpty(el.FacilityAddress)
      && this.stringUtils.isNotEmpty(el.FacilityName));

    this.submitBrokerAuditDataRequestModel.SubmitAsDraft = false;
    this.submitBrokerAuditDataRequestModel.BrokerAuditData = this.brokerAuditDataModel;
    this.brokerAuditDeclarationService.submitBrokerAuditDeclarationData(this.submitBrokerAuditDataRequestModel)
      .subscribe((response: SubmitBrokerAuditDataResponseModel) => {

        response.UserMessages.forEach(msg => {
          this.userMessages.push(msg);
        })
        this.currentPageWatcher.sendUserMessages(this.userMessages);
        if (response.Summary == 0) {
          this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel = response.Workflow;
          //save startFunction with updated workflow in localstorage
          this.brokerAuditDeclarationService.updateStartFunction(this.startFunction);
          this.router.navigate(['/questionnaireAuditDeclaration']).then(() => {
            this.startFunctionService.getNotifyStepInProgress().emit(true);

          });
          this.userMessages = [];
        }
        if (response.Summary == 1) {
          $("html, body").animate({ scrollTop: 0 }, "slow");
          this.userMessages = [];

        }

        if (response.Summary == 2) {
          this.currentPageWatcher.displayUserMessage = true;
          this.router.navigate(["/home"]);
          this.userMessages = [];
        }
      })

  }

  handleBadFormErrors() : boolean{
    this.currentPageWatcher.clearUserMessage();
      
    if ((this.offSiteStorageLocations.filter(el => el.FacilityAddress != "" && el.FacilityName != "").length == 0)
    ||(this.offSiteStorageLocations.filter(el => el.FacilityAddress == ""  && el.FacilityName != "").length > 0)
    ||(this.offSiteStorageLocations.filter(el => el.FacilityName == ""  && el.FacilityAddress != "").length > 0)) {
      let userMessage: MessageModel = {};
      userMessage.Alert = 3;
      userMessage.Description = "You must enter at least one complete Off-Site Storage Location.";
      this.userMessages.push(userMessage);
      $("html, body").animate({ scrollTop: 0 }, "slow");
      this.currentPageWatcher.sendUserMessages(this.userMessages);
      this.userMessages = [];
      return true;
    }
      
      else {
          return false
        }
        
  }
  back() {
    //find last section = first section in the list with value less than 5 (actual section)
    let lastSection = Math.max.apply(Math, this.brokerAuditDeclarationService.brokerDataDeclarationSectionList.filter(function (x) { return x < 5 }));
    console.log(lastSection);

    switch (lastSection) {

      case 1: {
        this.router.navigate(['/section1BaData']);
        break;
      }
      case 2: {
        this.router.navigate(['/section2BaData']);

        break;
      }
      case 3: {
        this.router.navigate(['/section3BaData']);

        break;
      }
      case 4: {
        this.router.navigate(['/section4BaData']);

        break;
      }
      default: {
        this.router.navigate(['/brokerageInformation']).then(
          ()=>this.currentPageWatcher.sendStepMessage(this.startFunction.Workflow.Steps[1].StepMessage));

        break;
      }
    }
  }

  //back browser button
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.back();
  }
  ngOnDestroy(): void {
    if(this.currentPageWatcher.displayUserMessage == false){
      this.currentPageWatcher.clearUserMessage();
    }

    this.SaveDataSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/broker/broker-audit-declaration/section5-ba-data-storage-location/section5-ba-data-storage-location.component.ts